import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#3F4A38] text-[#F7F4ED] mt-24 rounded-t-[2.5rem]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-16 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="font-serif text-4xl sm:text-5xl font-semibold tracking-tight">Mary Pawpins</p>
          <p className="mt-4 text-sm leading-relaxed text-[#F7F4ED]/70 max-w-sm">
            Dog walking, in-home pet sitting and home visits across Inverness and the
            Highlands, personally delivered by Carly, with Mary's Meadow at the heart
            of it all.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a href="https://www.instagram.com/marypawpins.inverness/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="w-10 h-10 rounded-full border border-[#F7F4ED]/25 flex items-center justify-center hover:bg-[#F7F4ED]/10 transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61586003890175" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-10 h-10 rounded-full border border-[#F7F4ED]/25 flex items-center justify-center hover:bg-[#F7F4ED]/10 transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="text-xs uppercase tracking-[0.22em] text-[#D8B7B0] font-semibold">Services</p>
          <ul className="mt-5 space-y-3 text-sm text-[#F7F4ED]/80">
            <li><Link to="/dog-walking" className="hover:text-white transition-colors">Dog Walking · Mon, Tue &amp; Fri</Link></li>
            <li><Link to="/pet-sitting" className="hover:text-white transition-colors">In-home Pet Sitting</Link></li>
            <li><Link to="/home-visits" className="hover:text-white transition-colors">Home Visits</Link></li>
            <li><Link to="/prices" className="hover:text-white transition-colors">Prices</Link></li>
            <li><Link to="/faqs" className="hover:text-white transition-colors">FAQs</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.22em] text-[#D8B7B0] font-semibold">Get in touch</p>
          <ul className="mt-5 space-y-3 text-sm text-[#F7F4ED]/80">
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#B9A58D]" />
              <a href="mailto:marypawpinsinverness@gmail.com" data-testid="footer-email" className="hover:text-white transition-colors">marypawpinsinverness@gmail.com</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#B9A58D]" />
              <a href="tel:+447749040175" data-testid="footer-phone" className="hover:text-white transition-colors">07749 040175</a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-[#B9A58D]" />
              <span>Inverness &amp; the Highlands</span>
            </li>
          </ul>
          <p className="mt-6 text-xs text-[#F7F4ED]/50 leading-relaxed">
            Fully insured · Canine first-aid trained · Founder-led care
          </p>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-[#F7F4ED]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-[#F7F4ED]/50">© {new Date().getFullYear()} Mary Pawpins Pet Care, Inverness.</p>
        <div className="flex gap-6 text-xs text-[#F7F4ED]/50">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy</Link>
          <Link to="/faqs" className="hover:text-white transition-colors">Policies</Link>
        </div>
      </div>
    </div>
  </footer>
);
